import { IBudgetConstruction } from '@apply/api/src/api/ApplyApi';
import { MoneyBox } from '@apply/components';
import { formatCurrencyOrUndefined } from '@apply/ui';
import { ApplicationQuestionReviewItem } from '../../../../components/ApplicationQuestionReviewItem';
import { useBudgetConstructionField } from '../../../../../queries/useBudgetConstructionField';

interface DrivewayAndWalksProps {
    required?: boolean;
    propertyGuid: string;
    isReview?: boolean;
}

export const DrivewayAndWalks: React.FC<DrivewayAndWalksProps> = ({ required = false, propertyGuid, isReview = false }) => {
    const [drivewayAndWalks, set_drivewayAndWalks] = useBudgetConstructionField<number>(
        propertyGuid,
        (b) => b.values?.['Final Steps']?.['Driveway & Walks'] ?? 0,
        (b, v) => ({ ...b, values: { ...b.values, 'Final Steps': { ...b.values?.['Final Steps'], 'Driveway & Walks': v } } })
    );
    const label = 'Driveway and Walks';
    return (
        <>
            {isReview ? (
                <ApplicationQuestionReviewItem
                    label={label}
                    value={formatCurrencyOrUndefined(drivewayAndWalks)}
                />
            ) : (
                <MoneyBox
                    id={'drivewayAndWalks'}
                    allowNegative={false}
                    value={drivewayAndWalks}
                    onChange={(value) => set_drivewayAndWalks(value)}
                    required={required}
                    label={label}
                />
            )}
        </>
    );
};
